import http from "@/http-common"

class MessageDataService {
    getAll(url) {
        return http.get(`messages${ url }`)
    }

    get(id) {
        return http.get(`messages/${ id }`)
    }

    post(data) {
        return http.post('messages', data)
    }

    patch(id, data, headers) {
        return http.patch(`messages/${ id }`, data, headers)
    }

    delete(id) {
        return http.delete(`messages/${ id }`)
    }
}

export default new MessageDataService()